import styled from "styled-components";

export const FormWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const FiltersWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    
    label {
        font-weight: 500;
        color: var(--text-color-primary);
        color: var(--text-color-primary);
    }
`;

export const TableWrapper = styled.div`
    flex: 1;
    /* padding: 14px; */
    /* border-radius: 1rem; */
    /* background-color: var(--theme-color-tertiary); */
    /* border: 1px solid var(--table-border-color); */
    display: flex;
    flex-direction: column;
    gap: 4px;
    overflow: hidden;
`;

export const ActionsContainer = styled.div`
    display: flex;
    gap: 10px;
    justify-content: flex-end;
`;

export const EmptyWrapper = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
`;